import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white website-visitors radius-7" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "mb-lg-15 d-sm-flex align-items-center justify-content-between" }
const _hoisted_4 = { class: "card-title fw-bold mb-0" }
const _hoisted_5 = {
  id: "websiteVisitorsChart",
  class: "chart"
}
const _hoisted_6 = { class: "expected-earnings-box" }
const _hoisted_7 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing d-flex justify-content-around" }
const _hoisted_8 = { class: "list ps-0 mb-0 list-unstyled mt-15" }
const _hoisted_9 = { class: "text-muted position-relative fw-medium" }
const _hoisted_10 = { class: "text-black fw-bold" }
const _hoisted_11 = { class: "text-muted position-relative fw-medium" }
const _hoisted_12 = { class: "text-black fw-bold" }
const _hoisted_13 = { class: "text-muted position-relative fw-medium" }
const _hoisted_14 = { class: "text-black fw-bold" }
const _hoisted_15 = { class: "list ps-0 mb-0 list-unstyled mt-15" }
const _hoisted_16 = { class: "text-muted position-relative fw-medium" }
const _hoisted_17 = { class: "text-black fw-bold" }
const _hoisted_18 = { class: "text-muted position-relative fw-medium" }
const _hoisted_19 = { class: "text-black fw-bold" }
const _hoisted_20 = { class: "text-muted position-relative fw-medium" }
const _hoisted_21 = { class: "text-black fw-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.getDashboardSemesterCards.semester) + "° Semestre", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_apexchart, {
          type: "bar",
          height: "385",
          options: _ctx.websiteVisitorsChart,
          series: [{name: 'Quantidade',data: [{x: 'Sucesso', y: _ctx.getDashboardSemesterCards.total_success, fillColor: '#1D6FF2'}, {x: 'Erro', y: _ctx.getDashboardSemesterCards.total_error, fillColor: '#C33F52'}]}]
        }, null, 8, ["options", "series"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            _createElementVNode("li", _hoisted_9, [
              _createTextVNode(" Upload com sucesso: "),
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.getDashboardSemesterCards.total_success), 1)
            ]),
            _createElementVNode("li", _hoisted_11, [
              _createTextVNode(" Tempo total: "),
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.convertTime(_ctx.getDashboardSemesterCards.total_time)), 1)
            ]),
            _createElementVNode("li", _hoisted_13, [
              _createTextVNode(" AM: "),
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.getDashboardSemesterCards.am), 1)
            ])
          ]),
          _createElementVNode("ul", _hoisted_15, [
            _createElementVNode("li", _hoisted_16, [
              _createTextVNode(" Upload com erro: "),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.getDashboardSemesterCards.total_error), 1)
            ]),
            _createElementVNode("li", _hoisted_18, [
              _createTextVNode(" Tamanho total: "),
              _createElementVNode("span", _hoisted_19, _toDisplayString((_ctx.getDashboardSemesterCards.total_size / (1024 * 1024)).toFixed(2) + " MB"), 1)
            ]),
            _createElementVNode("li", _hoisted_20, [
              _createTextVNode(" PM: "),
              _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.getDashboardSemesterCards.pm), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}